{
  "es": {
    "headlines": {
      "admin": {
        "blueprints": {
          "index": "Planos",
          "materials": "Materiales",
          "stats": "Estadísticas",
          "sources": "Fuentes"
        },
        "missions": {
          "index": "Misiones"
        },
        "dashboard": {
          "title": "Panel de control",
          "visitsPerDay": "Visitas por día",
          "visitsPerMonth": "Visitas por mes",
          "mostViewedPages": "Páginas más vistas",
          "registrationsPerMonth": "Registros por mes"
        },
        "models": {
          "index": "Modelos",
          "edit": {
            "index": "Editar modelo",
            "fleetchart": "Imágenes de gráfico de flota",
            "positions": "Posiciones de tripulación",
            "hardpoints": "Puntos de montaje",
            "cargoAndFuel": "Combustible",
            "cargoHolds": "Bodegas de carga",
            "metrics": "Métricas",
            "prices": "Precios",
            "docks": "Muelles",
            "modules": "Módulos",
            "paints": "Pinturas",
            "videos": "Videos",
            "images": "Imágenes",
            "itemPrices": "Precios de artículos",
            "linkModule": "Vincular módulo existente",
            "loaners": "Prestados",
            "snubCrafts": "Snub Crafts",
            "upgrades": "Mejoras",
            "packages": "Paquetes",
            "linkUpgrade": "Vincular mejora existente",
            "history": "Historial de cambios"
          },
          "new": "Nuevo modelo",
          "show": "Modelo",
          "images": "Imágenes",
          "tableConfigurationModal": "Configuración de tabla"
        },
        "components": {
          "index": "Componentes",
          "new": "Nuevo componente",
          "edit": {
            "index": "Editar componente",
            "itemPrices": "Precios de artículos",
            "history": "Historial de cambios"
          }
        },
        "modelPaints": {
          "index": "Pinturas",
          "new": "Nueva pintura",
          "edit": "Editar pintura",
          "copy": "Copiar pintura a la nave",
          "bulkCopy": "Copiar %{count} pinturas a la nave"
        },
        "modelModules": {
          "index": "Módulos",
          "new": "Nuevo módulo",
          "edit": "Editar módulo",
          "models": "Modelos vinculados",
          "prices": "Precios",
          "hardpoints": "Puntos de montaje",
          "docks": "Muelles",
          "cargoHolds": "Bodegas de carga",
          "history": "Historial de cambios"
        },
        "unlistedModels": {
          "index": "Naves en los archivos del juego sin modelo",
          "link": "Vincular con una nave del catálogo"
        },
        "manufacturers": {
          "index": "Fabricantes",
          "new": "Nuevo fabricante",
          "edit": {
            "index": "Editar fabricante"
          }
        },
        "announcements": {
          "index": "Anuncios",
          "new": "Nuevo anuncio",
          "edit": "Editar anuncio",
          "deliveries": "Envío"
        },
        "supporterContributions": {
          "index": "Contribuciones de patrocinadores",
          "new": "Nueva contribución de patrocinador",
          "edit": "Editar contribución de patrocinador",
          "perMonth": "Contribuciones por mes"
        },
        "fundingGoals": {
          "index": "Objetivos de financiación",
          "new": "Nuevo objetivo de financiación",
          "edit": "Editar objetivo de financiación"
        },
        "users": {
          "index": "Usuarios",
          "edit": "Editar usuario",
          "fleets": "Flotas",
          "inventories": "Inventarios",
          "supporterContributions": "Aportaciones de colaboradores"
        },
        "vehicles": {
          "index": "Vehículos",
          "edit": "Editar vehículo"
        },
        "fleets": {
          "index": "Flotas",
          "edit": "Editar flota",
          "members": "Miembros",
          "memberEdit": "Editar miembro",
          "history": "Historial de cambios",
          "roles": "Roles",
          "inventories": "Inventarios",
          "inventoryItems": "Entradas"
        },
        "destroyedFleets": {
          "index": "Flotas eliminadas"
        },
        "admins": {
          "index": "Administradores",
          "new": "Nuevo administrador",
          "edit": "Editar administrador"
        },
        "oauthApplications": {
          "index": "Aplicaciones OAuth",
          "new": "Nueva aplicación OAuth",
          "edit": "Editar aplicación OAuth",
          "reject": "Rechazar %{name}",
          "rejectBulk": "Rechazar %{count} aplicaciones"
        },
        "features": {
          "index": "Indicadores de características",
          "show": "Detalles de la función",
          "globalState": "Estado global",
          "groups": "Grupos",
          "actors": "Actores",
          "selfService": "Autoservicio",
          "percentageOfActors": "Porcentaje de actores",
          "percentageOfTime": "Porcentaje de tiempo",
          "addActor": "Agregar actor",
          "history": "Historial"
        },
        "rsiApiStatus": {
          "index": "Estado de API RSI"
        },
        "images": {
          "index": "Imágenes"
        },
        "imports": {
          "index": "Importaciones"
        },
        "notifications": {
          "index": "Notificaciones"
        },
        "commodities": {
          "index": "Commodities",
          "new": "New Commodity",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "new": "New Equipment",
          "edit": {
            "index": "Edit Equipment",
            "itemPrices": "Item Prices"
          }
        },
        "visualTests": {
          "index": "Pruebas Visuales",
          "notifications": "Notificaciones"
        },
        "buildCompare": {
          "index": "Comparar compilaciones"
        }
      },
      "welcome": "Welcome to",
      "welcomeShips": "Latest Ships",
      "welcomeImages": "Random Images",
      "ships": {
        "index": "Ships Index",
        "fleetchart": "Gráfico de flota de naves"
      },
      "images": "Images Index",
      "stats": "Estadísticas",
      "notFound": "Error de navegación",
      "forbidden": "Acceso denegado",
      "subscriptionRequired": "Función de mecenas",
      "featureNotReady": "Próximamente",
      "inviteInvalid": "Enlace de invitación no válido",
      "accessDenied": "Acceso denegado",
      "serverError": "Error del servidor",
      "offline": "Conexión perdida",
      "invalidRequest": "Solicitud no válida",
      "comments": "Comentarios",
      "login": "Iniciar sesión",
      "hangar": {
        "index": "Mi hangar",
        "preview": {
          "h1": "Vista previa de mi hangar",
          "h2": "Your personal Hangar requires an FleetYards.net Account",
          "h3": "What Features does the Hangar include?"
        },
        "alternativeNames": "Nombres alternativos",
        "stats": "Estadísticas",
        "public": "Hangar de %{user}",
        "import": "Importar",
        "wishlist": "Lista de deseos",
        "publicStats": "Estadísticas",
        "publicWishlist": "Lista de deseos de %{user}",
        "resetIngame": "Restablecer naves del juego después del reinicio",
        "imports": "Importaciones"
      },
      "syncExtension": "Sincronizar hangar RSI",
      "editMyVehicle": "Edit my %{vehicle}",
      "nameMyVehicle": "Name my %{vehicle}",
      "editGroups": "Edit Groups",
      "newVehicles": "Add Ships",
      "myVehicleAddons": "Add Modules / Upgrades for %{vehicle}",
      "myVehicleLoadouts": "Loadouts para %{vehicle}",
      "addToHangar": "Add \"%{model}\" to your Hangar",
      "impressum": "Aviso legal",
      "privacy": "Política de privacidad",
      "cookie": "Cookie policy",
      "requestPassword": "Solicitar contraseña",
      "changePassword": "Cambiar contraseña",
      "confirmAccess": "Confirm access",
      "setEmail": "Establecer dirección de correo",
      "oauthAuthorize": "Autorizar aplicación",
      "filterModels": "Filter Ships",
      "filterVehicles": "Filter Hangar",
      "fleets": {
        "owners": "Owners",
        "add": "Crear una nueva flota",
        "invites": "Invitaciones de flota",
        "inviteUrls": "Invite Urls",
        "members": {
          "index": "Members",
          "worldmap": "Mapa mundial de miembros",
          "starmap": "Mapa estelar de miembros"
        },
        "squadrons": {
          "index": "Escuadrones",
          "create": "Crear escuadrón",
          "edit": "Editar escuadrón",
          "formDetails": "Detalles",
          "formAppearance": "Apariencia",
          "formDiscord": "Discord",
          "teams": "Equipos",
          "addMembers": "Añadir miembros",
          "members": "Miembros"
        },
        "stats": "Estadísticas",
        "preview": {
          "h1": "Vista previa de flota",
          "h2": "To create a Fleet you need to have a FleetYards.net Account",
          "h3": "What Features does your Fleet include?"
        },
        "settings": {
          "fleet": "Fleet Settings",
          "membership": "Membership Settings",
          "roles": "Roles de flota",
          "squadrons": "Escuadrones de la flota",
          "allies": "Aliados de la flota",
          "notifications": "Configuración de notificaciones",
          "inAppNotifications": "Notificaciones en la app",
          "discord": "Discord",
          "calendar": "Calendario",
          "contracts": "Configuración de contratos",
          "features": "Funciones de flota"
        },
        "inviteMember": "Invite new Member",
        "calendarSubscription": "Suscripción al calendario",
        "missions": {
          "index": "Misiones",
          "create": "Crear misión",
          "edit": "Editar misión",
          "editDetails": "Detalles",
          "editDescription": "Descripción y portada",
          "editTeams": "Equipos y plazas",
          "teams": "Equipos",
          "ships": "Naves",
          "slots": "Plazas",
          "addTeam": "Agregar equipo",
          "editTeam": "Editar equipo",
          "addShip": "Agregar nave",
          "editShip": "Editar nave"
        },
        "events": {
          "expandShip": "Añadir puestos",
          "index": "Eventos",
          "calendar": "Calendario",
          "create": "Crear evento",
          "edit": "Editar evento",
          "editDetails": "Detalles",
          "editSchedule": "Programación",
          "editSignup": "Inscripción",
          "editDescription": "Descripción y portada",
          "editTeams": "Equipos y plazas",
          "spawn": "Generar evento",
          "details": "Detalles del evento",
          "schedule": "Programación",
          "settings": "Configuración",
          "lifecycle": "Ciclo de vida",
          "signupTitle": "Apúntame",
          "yourSignup": "Tu inscripción",
          "spawnedFrom": "Generado a partir de esta misión",
          "pickTemplate": "Elige una plantilla de misión",
          "unassignedSignups": "Inscripciones sin asignar",
          "eventTeam": "Equipo del evento",
          "grantRole": "Otorgar un rol",
          "editTeam": "Editar equipo",
          "addTeam": "Agregar equipo",
          "editShip": "Editar nave",
          "addShip": "Agregar nave",
          "assignSlotFor": "Asignar plaza para %{username}",
          "reassignSlotFor": "Reasignar plaza para %{username}"
        },
        "memberNickname": "Apodo del miembro",
        "contracts": {
          "index": "Contratos",
          "create": "Crear contrato",
          "edit": "Editar contrato",
          "progress": "Progreso",
          "crew": "Tripulación",
          "items": "Mercancías",
          "editItem": "Editar mercancías",
          "addItem": "Añadir mercancías",
          "views": {
            "open": "Contratos",
            "closed": "Contratos cerrados",
            "mine": "Mis contratos",
            "completed": "Contratos completados"
          }
        }
      },
      "hangarGroup": {
        "create": "Create Group",
        "edit": "Edit Group"
      },
      "compare": {
        "ships": "Comparar naves"
      },
      "settings": {
        "account": "Cuenta",
        "profile": "Configuración del perfil",
        "hangar": "Configuración del hangar",
        "privacy": "Configuración de privacidad",
        "features": "Indicadores de características",
        "connections": "Conexiones",
        "oauthApplications": "Aplicaciones OAuth",
        "notifications": "Configuración de notificaciones",
        "verify": "Verify your RSI Account",
        "security": {
          "index": "Seguridad de la cuenta",
          "twoFactor": "Two-factor Authentication"
        },
        "twoFactor": {
          "enable": "Enable Two-factor Authentication",
          "disable": "Disable Two-factor Authentication",
          "backupCodes": "Generate Two-Factor Backup Codes"
        },
        "calendar": "Suscripción al calendario",
        "donations": "Donaciones"
      },
      "oauthApplications": {
        "new": "Nueva aplicación OAuth",
        "edit": "Editar aplicación OAuth"
      },
      "roadmap": "Hoja de ruta de naves",
      "tools": {
        "index": "Herramientas",
        "travelTimes": "Tiempos de viaje",
        "cargoGrids": "Grillas de carga"
      },
      "rsiVerification": "Verify your RSI-Account",
      "hangarGuideEmpty": "Not much to see here?",
      "hangarGuide": "Hangar Guide",
      "support": "Support FleetYards.net",
      "supporters": "Gracias a nuestros patrocinadores",
      "supportHint": {
        "hangarSync": "Nos alegra haber ayudado con tu sincronización",
        "vehicleAdded": "Tu hangar está creciendo",
        "fleetCreated": "Una nueva flota — ¡genial!",
        "loginMilestone": "Gracias por seguir con nosotros",
        "visitMilestone": "¿Te gusta FleetYards?"
      },
      "vehicle": {
        "bulkGroupEdit": "Agregar/eliminar grupos"
      },
      "pagination": {
        "count": "%{current} de %{total}"
      },
      "models": {
        "index": "Modelos"
      },
      "modals": {
        "models": {
          "displayOptions": "Opciones de visualización"
        }
      },
      "visualTests": {
        "overview": "Resumen",
        "panels": "Paneles",
        "buttons": "Botones",
        "media": "Multimedia",
        "charts": "Gráficos",
        "blueprints": "Planos",
        "squadrons": "Escuadrones",
        "chips": "Chips de pruebas visuales",
        "events": "Eventos",
        "typography": "Tipografía",
        "forms": "Formularios",
        "tables": "Tablas",
        "lists": "Listas",
        "metrics": "Métricas",
        "states": "Estados",
        "notifications": "Notificaciones",
        "syncModal": "Modal de sincronización",
        "overlays": "Superposiciones",
        "supportHint": "Aviso de apoyo",
        "notificationCenter": "Centro de notificaciones",
        "themes": "Temas"
      },
      "logistics": {
        "index": "Logistics",
        "inventories": "Inventories",
        "requests": "Requests",
        "newRequest": "New Request",
        "requestItems": "Items",
        "comments": "Comments",
        "inventoryItems": "Inventory Items",
        "createInventory": "Create Inventory",
        "editInventory": "Edit Inventory",
        "createItem": "Add Item",
        "deposit": "Deposit",
        "withdrawal": "Withdrawal",
        "importCsv": "Import from CSV",
        "hangarInventories": "Hangar Inventories",
        "editItem": "Edit Entry",
        "editStockItem": "Edit Item",
        "transfer": "Transferir existencias",
        "transfers": "Transferencias",
        "acceptTransfer": "Aceptar transferencia",
        "reportTransfer": "Denunciar transferencia"
      },
      "notifications": {
        "index": "Notificaciones"
      },
      "payouts": {
        "index": "Pagos",
        "summary": "Resumen",
        "participants": "Participantes",
        "entries": "Movimientos",
        "balances": "Saldos",
        "transfers": "Lista de pagos",
        "addEntry": "Registrar dinero",
        "editEntry": "Editar movimiento",
        "addParticipant": "Añadir participante",
        "tours": {
          "index": "Expediciones",
          "create": "Crear expedición",
          "join": "Unirse a esta expedición"
        },
        "declineExpense": "Rechazar gasto"
      },
      "relationships": {
        "user": {
          "index": "Amigos",
          "add": "Añadir un amigo"
        },
        "fleet": {
          "add": "Añadir un aliado"
        }
      },
      "fleet": {
        "contractCovers": "Portadas de contrato"
      },
      "component": {
        "history": "Historial",
        "craftedFrom": "Se fabrica con",
        "identity": "Detalles",
        "metrics": "Métricas",
        "requiredTags": "Encaja en un puerto con",
        "tags": "Etiquetas"
      },
      "commodity": {
        "priceHistory": "Histórico de precios",
        "identity": "Detalles",
        "usedIn": "Usada en"
      },
      "commodities": {
        "index": "Mercancías"
      },
      "components": {
        "index": "Componentes"
      },
      "blueprints": {
        "index": "Planos"
      },
      "missions": {
        "index": "Misiones"
      },
      "missions": {
        "index": "Misiones"
      },
      "equipment": {
        "index": "Equipo",
        "metrics": "Métricas",
        "identity": "Detalles",
        "craftedFrom": "Se fabrica con"
      }
    }
  }
}
